import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../../actions';

//REDUCERS
const { reservationRequest } = actions.customer;
export default handleActions(
  {
    [combineActions(
      reservationRequest.create.toString(),
      reservationRequest.update.toString(),
      reservationRequest.postAsync.toString()
    )]: (reservationRequest, { payload }) => {
      return payload;
    }
  },
  Map()
);
